import type { AgentTaskModel } from "@fencyai/js";
import { useAgentTasks } from "@fencyai/react";
import { useCallback, useState } from "react";

type UseMemorySearchProps = {
  model: AgentTaskModel;
  fetchClientToken: () => Promise<{ clientToken: string }>;
};

export const useMemorySearch = ({ model, fetchClientToken }: UseMemorySearchProps) => {
  const [isSearching, setIsSearching] = useState(false);

  const fetchToken = useCallback(
    async (taskType: "StreamingChatCompletion" | "StructuredChatCompletion" | "MemoryChat" | "MemorySearch") => {
      void taskType;
      return fetchClientToken();
    },
    [fetchClientToken]
  );

  const { createAgentTask, latest } = useAgentTasks({
    fetchCreateAgentTaskClientToken: fetchToken,
  });

  const search = useCallback(
    async (query: string) => {
      const trimmed = query.trim();
      if (!trimmed || isSearching) {
        return;
      }

      setIsSearching(true);
      try {
        await createAgentTask({
          type: "MemorySearch",
          query: trimmed,
          model,
          language: "no",
          chunkLimit: 5,
          queryExpansion: { queryCount: 3 },
        });
      } finally {
        setIsSearching(false);
      }
    },
    [createAgentTask, isSearching, model]
  );

  return {
    latest,
    isSearching,
    search,
  };
};
